/**
 * E16 — client-side mirror of app/core/rating_math.price_call / effective_ppm.
 *
 * The rating kernel is authoritative (Python, Decimal); this numeric
 * approximation exists ONLY for display columns ("Eff. PPM @ ref ACD")
 * so operators can see increment-aware economics next to the nominal
 * per-minute rate. Must stay in sync with rating_math — covered by the
 * test_rating_conformance suite on the backend side.
 *
 * effective_ppm: price of a refS-second call, expressed per minute.
 */
export function effPPM(ratePerMin: number, connectFee: number, inc: number, refS = 60): number {
  const incSafe = Math.max(1, Math.floor(inc || 1));
  const billable = Math.ceil(refS / incSafe) * incSafe;
  return (connectFee + billable * (ratePerMin / 60)) / (refS / 60);
}
